// extracted by mini-css-extract-plugin
export var centerText = "_7b-8";
export var container = "_7b-0";
export var doughnutContainer = "_7b-7";
export var legend = "_7b-a";
export var legendItemColorDisplay = "_7b-b";
export var legendItemLabel = "_7b-d";
export var legendItemValue = "_7b-c";
export var lg = "_7b-5";
export var maxWidth = "_7b-9";
export var md = "_7b-4";
export var responsive = "_7b-6";
export var sm = "_7b-3";
export var xs = "_7b-2";
export var xxs = "_7b-1";